/**
 * @module app.prospection.store.glpiTicketsCtrl
 */
function GlpiTicketsCtrl($scope, glpiService, $root, Notification) {
    let self = this;
    let store = $scope.storeCtrl.store;

    self.isLoading = false;

    store.tickets = [];
    self.error = {};

    // Get GLPI store's tickets
    self.getTickets = function getTickets() {
        self.error = {};
        self.isLoading = true;
        if(store.etat_magasin === 3){
            store.tickets.totalcount === 0;
            self.error = {
                error: true,
                message: 'Aucun ticket à afficher pour ce client'
            };
        }else {
            glpiService
                .getGLPITickets(store.identifiant_magasin)
                .then(function(tickets) {
                    store.tickets = tickets;
                    if (store.tickets.totalcount === 0) {
                        self.error = {
                            error: true,
                            message: 'Aucun ticket à afficher pour ce client'
                        };
                    }
                    self.isLoading = false;
                })
                .catch(function(err) {
                    self.error = {
                        error: true,
                        class: 'alert-danger',
                        message:
                            'Une erreur est survenue' +
                            (err.statusText ? ' : [' + err.status + '] ' + err.statusText + ' - ' + err.data : '')
                    };
                    self.isLoading = false;
                });
        }

    }

    self.observe = function (ticketId){
        glpiService.observe(ticketId).then(function(res){
            Notification.success(res);
        }).catch(function(err){
            console.log(err);
        })
    }

    function _offline() {
        self.error = {
            error: true,
            message: 'Vous ne pouvez pas accéder aux tickets GLPI en mode hors ligne'
        };
    }

    function _online() {
        store.tickets = [];
        self.error = {};
    }

    if ($root.online) {
        _online();
    }
    else {
        _offline();
    }

    $root.$on('online', _online);

    $root.$on('offline', _offline);
}

GlpiTicketsCtrl.$inject = ['$scope', 'glpiService', '$rootScope', 'Notification'];

angular.module('app.prospection.store.glpiTicketsCtrl', []).controller('GlpiTicketsCtrl', GlpiTicketsCtrl);
